export default __webpack_public_path__ + "static/media/right-arrow-head.749d6a05.svg";